const accountFeaturesUrl = "v1/utility/account-management/product/features";
export {
  accountFeaturesUrl
};
//# sourceMappingURL=endpoints.js.map
